import { createFileRoute } from '@tanstack/react-router';
import { lazy } from 'react';

const Gallery = import.meta.env.DEV
	? lazy(() => import('@/prototype/_kit/host').then((m) => ({ default: m.PrototypeGallery })))
	: () => null;

export const Route = createFileRoute('/prototype/')({
	component: Gallery,
});
